module.exports = __webpack_public_path__ + "img/公安.eaa3ab36.png";